export const ProductOptionType = {
    SELECTION: 0,
    EXTRA: 1,
}